import React from 'react';
import { Link } from 'react-router-dom';
import { formatExpectedArrivalDate } from '../../../../utils/utils';
import { ORDER_STATUS_LABELS, PRODUCT_STATUS_LABELS } from './procurementUtils';

export default function ProcurementOrderLines({ orders }) {
  return (
    <ul className='procurement-order-lines'>
      {orders.map(line => (
        <li key={`${line.orderId}-${line.productId}-${line.productStatus}`}>
          <div>
            <Link to={`/admin/order/${line.orderId}`} className='font-weight-bold'>
              Замовлення #{line.orderId}
            </Link>
            <small className='text-muted d-block'>
              {ORDER_STATUS_LABELS[line.orderStatus] || line.orderStatus}
              {line.orderCreatedAtDisplay ? ` · ${line.orderCreatedAtDisplay}` : ''}
            </small>
          </div>
          <div>
            {PRODUCT_STATUS_LABELS[line.productStatus] || line.productStatus || 'Статус не вказано'}
            {line.expectedArrivalDate && (
              <small className='d-block'>
                Очікується: {formatExpectedArrivalDate(line.expectedArrivalDate)}
              </small>
            )}
          </div>
          <div>
            <strong>Не забезпечено: {line.missingQuantity} шт</strong>

          </div>
        </li>
      ))}
    </ul>
  );
}
